import React from 'react';

export interface CardProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  hoverable?: boolean;
  flat?: boolean;
  padding?: boolean;
}

export const Card: React.FC<CardProps> = ({
  children,
  className = '',
  style,
  hoverable = false,
  flat = false,
  padding = true,
}) => {
  return (
    <div
      className={[
        'ds-card',
        hoverable ? 'ds-card--hoverable' : '',
        flat ? 'ds-card--flat' : '',
        !padding ? 'ds-card--no-pad' : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      style={style}
    >
      {children}
    </div>
  );
};

export default Card;
